import React, { FC } from 'react';
import { View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { isPhone } from '@helpers';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import BackButton from '@components/common/backButton';
import DashboardScopeTabs from '@v2/pages/dashboard/common/components/DashboardScopeTabs';
import DashboardHeaderResultTypeChip from '@v2/pages/dashboard/common/components/DashboardHeaderResultTypeChip';
import { DASHBOARD_BACK_BUTTON_FONT_TYPE, DASHBOARD_BACK_BUTTON_ICON_CONFIG } from '@v2/pages/dashboard/common/constants/backButton';

import { useManageDashboardShowAllHeader } from './hooks/useManageDashboardShowAllHeader';
import { ContainerStyle } from '@interfaces/base';
import { SHOW_ALL_LAYOUT } from '@v2/pages/dashboard/modules/showAll/components/DashboardShowAll/constants';

interface DashboardShowAllHeaderProps extends WithColor, ContainerStyle {}

const DashboardShowAllHeader: FC<DashboardShowAllHeaderProps> = ({ containerStyle }) => {
  const { scope, onSelectScope, onBack } = useManageDashboardShowAllHeader();

  const leftCluster = (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: scale(12), marginLeft: -scale(12) }}>
      <BackButton
        backArrow
        text="Dashboard"
        onPress={onBack}
        testID={TEST_IDS.dashboardShowAll.header.back}
        fontType={DASHBOARD_BACK_BUTTON_FONT_TYPE}
        iconConfig={DASHBOARD_BACK_BUTTON_ICON_CONFIG}
      />
      {!isPhone && <DashboardHeaderResultTypeChip testID={TEST_IDS.dashboardShowAll.header.resultTypeChip} />}
    </View>
  );

  const tabs = <DashboardScopeTabs scope={scope} onSelectScope={onSelectScope} testIDForTab={TEST_IDS.dashboardShowAll.header.scopeTab} />;

  if (isPhone) {
    return (
      <View style={[{ gap: scale(SHOW_ALL_LAYOUT.header.marginVerticalMobile) }, containerStyle]}>
        {leftCluster}
        {tabs}
      </View>
    );
  }

  return (
    <View style={[{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }, containerStyle]}>
      <View style={{ position: 'absolute', left: 0 }}>{leftCluster}</View>
      {tabs}
    </View>
  );
};

export default ColorWrapper(DashboardShowAllHeader);
